export default __webpack_public_path__ + "static/logo1-f75ef3b918f2511a0125eaea0bd165bc.jpeg";